import ButtonNav from "components/ButtonNav"
import React, { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { marketingActions } from "redux/marketing/slice/user"

function MenuNavBar(props) {
  const { isReviewMode = false } = props
  const dispatch = useDispatch()
  const { menuImageList } = useSelector((store) => store.superAdmin)
  const { reviewMenuCategories } = useSelector((store) => store.marketing?.menu)
  const [menuCategoryList, setMenuCategoryList] = useState([])

  function handleButtonNav(item) {
    let itemsLink = {}
    if (props.isEdit) {
      itemsLink = { item: item, category: props.subCategory || "", list: "Detailed View" }
    } else {
      itemsLink = {
        item: item,
        category: props.subCategory || "",
        list: "Summary View"
      }
    }
    dispatch(marketingActions.setMenuLink(itemsLink))
  }

  React.useEffect(() => {
    // Use reviewMenuCategories when in review mode, otherwise use menuImageList
    const dataSource = isReviewMode ? reviewMenuCategories : menuImageList
    const newMenuList = dataSource?.map((item) => {
      return {
        name: item.name,
        value: item.name.toLowerCase()
      }
    })

    setMenuCategoryList(newMenuList)
  }, [menuImageList, reviewMenuCategories, isReviewMode])

  return (
    <>
      {menuCategoryList?.map((item, i) => {
        return (
          <ButtonNav
            style={{ marginRight: 12, marginTop: 12 }}
            onPress={() => handleButtonNav(item?.value)}
            key={i}
            isActive={props.activeTab === item.value ? true : false}>
            {item.name}
          </ButtonNav>
        )
      })}
    </>
  )
}

export default MenuNavBar
